<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import { computed } from 'vue'
import type { PropType } from 'vue'

import clsx from 'clsx'

import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const props = defineProps({
    editor: {
        type: Object as PropType<Editor>,
        required: true
    },
    isDark: {
        type: Boolean,
        required: true
    },
    active: {
        type: Boolean as PropType<boolean | null>,
        default: null
    }
})

const isActive = computed(() => {
    return typeof props.active === 'boolean'
        ? props.active
        : props.editor.isActive('italic')
})

const onToggleItalic = () => {
    betaStore.getTextEditorCommandChain(props.editor)?.toggleItalic().run()
}
</script>

<template>
    <button
        @click="onToggleItalic"
        :disabled="!editor.can().chain().focus().toggleItalic().run()"
        :class="
            clsx(
                'action-italic',
                isDark ? 'dark' : 'light',
                isActive ? 'is-active' : 'is-deactive'
            )
        "
    >
        <span class="sr-only">Italic</span>

        <svg
            class="w-[25px] h-6"
            stroke="currentColor"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.5526 19L14.4474 5M10.5526 19H6.5M10.5526 19H14.6052M14.4474 5H10.3948M14.4474 5H18.5"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</template>

<style scoped>
.action-italic.light svg {
    @apply stroke-[#060606];
}

.action-italic.dark svg {
    @apply stroke-[#FAFAFA];
}

.action-italic.is-deactive svg {
    @apply opacity-60;
}

.action-italic.is-active svg {
    @apply opacity-100;
}
</style>
